<template>
  <div class="pay-result">
    <img class="icon" :src=resultMap[result].icon :alt=resultMap[result].text>
    <p class="text">{{resultMap[result].text}}</p>
    <p class="time">{{time}}秒后返回主页面</p>
  </div>
</template>

<script>
import wait from './imgs/wait.png';
import success from './imgs/success.png';
import fail from './imgs/fail.png';
import { searchResult } from '../api/index';
const resultMap = {
  0: {
    icon: wait,
    text: '正在查询支付结果...'
  },
  1: {
    icon: success,
    text: '支付成功'
  },
  2: {
    icon: fail,
    text: '支付失败'
  }
};
export default {
  name: 'payResult',
  data () {
    return {
      resultMap,
      result: this.$route.query.result || 0,
      paymentId: this.$route.query.paymentId || null,
      time: 5,
      timer: null,
      status: 0,
      timeout: null
    };
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer);
      clearTimeout(this.timeout);
    }
  },
  mounted () {
    this.goActivityList();
    // result=0 说明是h5支付需要调接口查询支付结果
    if (Number(this.result) === 0) {
      setTimeout(() => {
        this.goSearch();
      }, 200);
    }
  },
  methods: {
    async goSearch () {
      const paymentId = this.paymentId;
      const res = await searchResult({ paymentId });
      if (res.data.errcode !== 'SUCCESS') {
        this.$toast(res.data.msg);
        return;
      }
      this.status = res.data.data.status;
      if (this.status === 0) {
        // 查询支付结果状态如果是0表示正在支付，我们就再查一次支付结果
        if (this.timeout) {
          clearTimeout(this.timeout);
        }
        this.timeout = setTimeout(() => {
          this.goSearch();
        }, 1000);
      } else if (this.status === 1) {
      // 查询支付结果状态如果是1支付成功否则支付失败
        this.result = 1;
      } else {
        this.result = 2;
      }
    },
    goActivityList () {
      if (this.timer) {
        clearInterval(this.timer);
      }
      let time = 5;
      this.timer = setInterval(() => {
        time--;
        this.time = time;
        // 对于h5支付需要查询支付结果的，如果倒计时3秒后，接口返回的status还是0正在支付中的话，是说明已取消支付，则修改状态为支付失败
        if (time <= 2 && this.status === 0 && Number(this.result) === 0) {
          this.result = 2;
        }
        if (time <= 0) {
          clearInterval(this.timer);
          this.$router.push('/doubleTwelve/list');
        }
      }, 1000);
    }
  }
};
</script>

<style scoped lang="scss">
  .pay-result {
    height: 100vh;
    background: rgba(245,245,245,1);
    text-align: center;
    .icon {
      display: inline-block;
      height: 266px;
      margin: 166px 0 30px 0;
    }
    .text {
      font-size: 40px;
      font-family: PingFangSC;
      font-weight: 500;
      color: rgba(0,0,0,1);
    }
    .time {
      font-size: 26px;
      font-family: PingFangSC;
      font-weight: 400;
      color: rgba(246,136,51,1);
      margin: 30px 0;
    }
  }
</style>
